export const staticCardsData = [
  {
    title: 'Team members without any goals',
    subTitle: '',
    value: 1,
    color: '',
  },
  {
    title: 'Team members with no check-ins',
    subTitle: '',
    value: 2,
    color: '',
  },
  {
    title: 'Average progress',
    subTitle: 'since last month',
    value: '8%',
    count: '8%',
    color: 'success',
  },
  {
    title: 'Team completion ranking',
    subTitle: 'since last month',
    value: '80%ile',
    count: '12%',
    color: 'success',
  },
];

export const lineChartData = {
  nodes: [
    {
      id: '121',
      name: "Jay Chandra's team",
    },
    {
      id: '122',
      name: "Ming Ye's team",
    },
    {
      id: '123',
      name: "George Weber's team",
    },
    {
      id: '124',
      name: "Helen Mirren's direct reports",
    },
  ],
  yaxisRange: {
    start: 0,
    end: 30,
  },
  series: [
    {
      id: '121',
      data: [12, 23, 30, 12],
    },
    {
      id: '122',
      data: [12, 13, 10, 12],
    },
    {
      id: '123',
      data: [0, 0, 0, 0],
    },
    {
      id: '124',
      data: [16, 27, 19, 10],
    },
  ],
  xaxis: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
};

export const barChartData = {
  nodes: [
    {
      color: {
        dark: '#B1E39F',
        light: '#B1E39F',
      },
      id: '121',
      name: 'On-Track',
    },
    {
      color: {
        dark: '#FFDE88',
        light: '#FFDE88',
      },
      id: '122',
      name: 'Off-Track',
    },
    {
      color: {
        dark: '#FAD4D4',
        light: '#FAD4D4',
      },
      id: '123',
      name: 'At-Risk',
    },
    {
      color: {
        dark: '#B1E39F',
        light: '#B1E39F',
      },
      id: '124',
      name: 'Closed & achieved',
    },
    {
      color: {
        dark: '#FCC88B',
        light: '#FCC88B',
      },
      id: '125',
      name: 'Closed & not achieved',
    },
    {
      color: {
        dark: '#FFAE99',
        light: '#FFAE99',
      },
      id: '126',
      name: 'Closed & dropped',
    },
  ],
  xaxis: ["Jay Chandra's team", "Ming Ye's team", "George Weber's team", "Helen Mirren's direct reports"],
  yaxisRange: {
    start: 0,
    end: 30,
  },
  series: [
    {
      id: '121',
      data: [1, 3, 5, 2],
    },
    {
      id: '122',
      data: [5, 2.4, 3, 1],
    },
    {
      id: '123',
      data: [4, 8, 7, 3],
    },
    {
      id: '124',
      data: [4, 8, 3, 3],
    },
    {
      id: '125',
      data: [3, 5, 5, 2],
    },
    {
      id: '126',
      data: [2, 5, 7, 1],
    },
  ],
};
